import React, { Component } from "react";
import jsSHA from "jssha";
import { axiosPost } from "../apis/useAxios";
//import { ameyo } from "../apis/ameyo-integration-v4_13";
import {
  SetSessionItem,
  ClearSessionItems,
  getCurrentLocation,
  getCurrencyIcon,
} from "../helper/appsession";
import { ApplicationType, LoginAssetType } from "../helper/fixcode";
import platform from "platform";
export class LoginPage extends Component {
  static displayName = LoginPage.name;
  constructor(props) {
    super(props);
    this.state = {
      isSubmitted: false,
      userName: "",
      password: "",
      pwdType: "password",
      errors: {
        userName: "",
        password: "",
      },
    };
  }

  calcHash = (value, authToken) => {
    try {
      let shaObj = new jsSHA("SHA-256", "TEXT", { encoding: "UTF8" });
      shaObj.update(value);
      let saltText = shaObj.getHash("HEX");

      let shaObj2 = new jsSHA("SHA-256", "TEXT", { encoding: "UTF8" });
      shaObj2.update(saltText + authToken);

      return shaObj2.getHash("HEX");
    } catch (error) {
      console.log(error);
    }
  };

  handleOnInputChange = (event) => {
    try {
      const target = event.target;
      const name = target.name;
      const value =
        target.type === "checkbox" || target.type === "radio"
          ? target.checked
          : target.value;
      let err = this.state.errors;
      switch (name) {
        case "userName":
          err.userName = "";
          if (value === "" || value.length <= 50) {
            this.setState({
              userName: value,
            });
          }
          break;
        case "password":
          err.password = "";
          if (value === "" || value.length <= 50) {
            this.setState({
              password: value,
            });
          }
          break;
        default:
          break;
      }
      this.setState({
        errors: err,
      });
    } catch (error) {
      console.log(error);
    }
  };

  isFormValid = () => {
    let formIsValid = true;
    try {
      let err = this.state.errors;
      err.userName = "";
      err.password = "";
      if (!this.state.userName) {
        formIsValid = false;
        err.userName = "Please enter username";
      }
      if (!this.state.password) {
        formIsValid = false;
        err.password = "Please enter password";
      }
      this.setState({
        errors: err,
      });
    } catch (error) {
      console.log(error);
    }
    return formIsValid;
  };

  handleOnSubmit = async (e) => {
    e.preventDefault();
    try {
      if (this.isFormValid()) {
        this.setState({
          isSubmitted: true,
        });
        const authToken = await axiosPost("/authenticate/token", {
          UserName: this.state.userName,
        });

        if (authToken.success) {
          const { lat, lng, ip } = await getCurrentLocation();
          const password = this.calcHash(this.state.password, authToken.token);
          const response = await axiosPost("/authenticate", {
            UserName: this.state.userName,
            Password: password,
            SessionId: authToken.token,
            AssetTypeId: LoginAssetType.Web,
            IpAddress: ip,
            ApplicationTypeId: ApplicationType.ApplicationTypeId,
            ApplicationName: ApplicationType.ApplicationTypeName,
            ApplicationVersion: ApplicationType.ApplicationVersion,
            Make: new Date().getFullYear(),
            MfgName: "Plexitech",
            GeolocationStatus: "",
            BrowserName: platform.name,
            BrowserVersion: platform.version,
            FirebaseToken: "",
            Latitude: lat,
            Longitude: lng,
          });

          if (response.success) {
            // debugger;
            // window.ameyo.integration.doLogin("sharadshitole","Sharad@2024","");
            // debugger;

            // try {
            //   window.myfunc();
            // }
            // catch (err) {
            //   console.log("Login/Ameyo", err.message);
            // }

            const userContext = response.payload;
            const currencyIcon = getCurrencyIcon(userContext.currencyCode);

            ClearSessionItems();
            SetSessionItem("authorized", true);
            SetSessionItem("authtoken", authToken.token);
            SetSessionItem("userid", userContext.userId);
            SetSessionItem("username", userContext.userName);
            SetSessionItem("password", this.state.password);
            SetSessionItem("firstname", userContext.firstName);
            SetSessionItem("lastname", userContext.lastName);
            SetSessionItem("usertypeid", userContext.userTypeId);
            SetSessionItem("usertypename", userContext.userTypeName);
            SetSessionItem("mobile", userContext.mobileNo);
            SetSessionItem("email", userContext.email);
            SetSessionItem("profilephotourl", userContext.profilePhotoUrl);
            SetSessionItem("customerid", userContext.customerId);
            SetSessionItem("branchid", userContext.branchId);
            SetSessionItem("branchname", userContext.brancName);
            SetSessionItem("currencyicon", currencyIcon);
            SetSessionItem("ameyousername", userContext.ameyoUserName);
            SetSessionItem("ameyopasscode", userContext.ameyoPasscode);
            SetSessionItem("ameyoaccess", userContext.ameyoAccess);
            SetSessionItem("trackingguid", userContext.trackingGuid);
            SetSessionItem(
              "userFeatureSetup",
              JSON.stringify(userContext.userFeatureSetup)
            );

            var locationPath = "";
            if (
              userContext.userFeatureSetup !== null &&
              userContext.userFeatureSetup.length > 0
            ) {
              locationPath = userContext.userFeatureSetup[0].requestPath;
              if (locationPath === null || locationPath === "") {
                var featureList = userContext.userFeatureSetup.filter(
                  (e) => e.subFeatureId > 0
                );
                if (featureList !== null && featureList.length > 0) {
                  locationPath = "/" + featureList[0].requestPath;
                }
              }
            } else {
              locationPath = "/permission";
            }

            //locationPath = userContext.userFeatureSetup !== null && userContext.userFeatureSetup.length > 0 ? userContext.userFeatureSetup[0].requestPath : "/permission";
            //console.log("locationPath: " + locationPath);
            window.location.href = locationPath;
          } else {
            let err = this.state.errors;
            err.password =
              response.message !== null && response.message !== ""
                ? response.message
                : "Invalid username/password";
            this.setState({
              errors: err,
            });
          }
        } else {
          let err = this.state.errors;
          err.password =
            authToken.message !== null && authToken.message !== ""
              ? authToken.message
              : "Invalid username/password";
          this.setState({
            errors: err,
          });
        }
      }
    } catch (err) {
      console.log("Login/handleOnSubmit", err.message);
      let error = this.state.errors;
      error.password = "Invalid username/password";
      this.setState({
        errors: error,
      });
    } finally {
      this.setState({
        isSubmitted: false,
      });
    }
  };

  handleOnPwdShowHide = async (e) => {
    try {
      e.preventDefault();
      e.stopPropagation();
      this.setState({
        pwdType: this.state.pwdType === "input" ? "password" : "input",
      });
    } catch (ex) {
      console.log(ex);
    }
  };

  render() {
    return (
      <form
        onSubmit={(e) => {
          this.handleOnSubmit(e);
        }}
      >
        <div className="logincontainer">
          <div>
            <img
              src="dist/img/zenplus-fleet-maangement-logo.svg"
              className="img-fluid"
            />
            {/* <img
              src="dist/img/utwiz-logo.png"
              className="img-fluid"
            /> */}
            <h3 className="subheading">
              <br />
              Sign in to your account!
            </h3>
          </div>
          <div className="form-group">
            <label htmlFor="email">Username</label>
            <div className="input-group mb-2">
              <input
                type="text"
                className="form-control"
                id="inlineFormInputGroup"
                placeholder="Please enter username"
                name="userName"
                onChange={(e) => {
                  this.handleOnInputChange(e);
                }}
                value={this.state.userName}
              />
            </div>
            {this.state.errors.userName.length > 0 && (
              <span className="text-danger" style={{ fontSize: "small" }}>
                {this.state.errors.userName}
              </span>
            )}
          </div>

          <div className="form-group">
            {/* <div className="d-block">
              <label htmlFor="password" className="control-label">
                Password
              </label>
              <div className="float-right">
                <a href="#" className="text-small text-link">
                  Forgot Password?
                </a>
              </div>
            </div> */}
            <div className="input-group mb-2">
              <input
                type={this.state.pwdType}
                className="form-control"
                id="inlineFormInputGroup"
                placeholder="Please enter password"
                name="password"
                onChange={(e) => {
                  this.handleOnInputChange(e);
                }}
                value={this.state.password}
              />
              <div className="input-group-prepend">
                <div className="input-group-text p-0 pl-2 pr-2">
                  <a
                    className="text-dark"
                    href="#"
                    onClick={(e) => {
                      this.handleOnPwdShowHide(e);
                    }}
                  >
                    <i
                      className={
                        this.state.pwdType === "input"
                          ? "fas fa-eye"
                          : "fas fa-eye-slash"
                      }
                    ></i>
                  </a>
                </div>
              </div>
            </div>
            {this.state.errors.password.length > 0 && (
              <span className="text-danger" style={{ fontSize: "small" }}>
                {this.state.errors.password}
              </span>
            )}
          </div>
          <div className="form-group">
            <div className="custom-control custom-checkbox">
              <input
                type="checkbox"
                name="remember"
                className="custom-control-input"
                tabIndex="3"
                id="remember-me"
              />
              <label className="custom-control-label" htmlFor="remember-me">
                Remember Me
              </label>
            </div>
          </div>
          <div className="form-group">
            <button
              type="submit"
              className="btn btn-primary btn-lg btn-block"
              tabIndex="4"
              title="Login"
            >
              Login &nbsp;
              <i className="fas fa-sign-in-alt" />
              {this.state.isSubmitted && <i className="buttonloader" />}
            </button>
            <br />
            <br />
            Powered by&nbsp;
            <img
              src="dist/img/plexitech-logo.png"
              className="img-fluid"
              alt="PlexiTech"
            />
            <br />
            &copy; Copyright 2024 UTWiz. Privacy Policy
          </div>
        </div>
        <div className="login-bg">
          <img src="../dist/img/main.png" className="img-fluid imgalignment" />
        </div>
      </form>
    );
  }
}
